import AuthFlowLayout from "./AuthFlowLayout";

export default AuthFlowLayout;
